import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const currentYear = "2026";

  return (
    <footer className="bg-black text-white py-8">
      <div className="container mx-auto px-4 grid md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div>
          <h3 className="text-xl font-bold mb-4">{t('footer.company.title')}</h3>
          <p className="text-gray-400">{t('footer.company.description')}</p>
        </div>
        
        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-4">{t('footer.quick_links.title')}</h4>
          <nav className="space-y-2">
            <Link to="/" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">
              {t('footer.quick_links.home')}
            </Link>
            <Link to="/downloads" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">
              {t('footer.quick_links.downloads')}
            </Link>
            <Link to="/about" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">
              {t('footer.quick_links.about')}
            </Link>
            <Link to="/contact" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">
              {t('footer.quick_links.contact')}
            </Link>
          </nav>
        </div>
        
        {/* Contact */}
        <div>
          <h4 className="font-semibold mb-4">{t('footer.contact.title')}</h4>
          <p>
            {t('footer.contact.email_label')}{' '}
            <a 
              href="mailto:confesz@tech-center.com" 
              className="clickable hover:text-yellow-400 transition-colors duration-300 bg-transparent"
            >
              confesz@tech-center.com
            </a>
          </p>
        </div>
        
        {/* Social Media */}
        <div>
          <h4 className="font-semibold mb-4">{t('footer.social.title')}</h4>
          <div className="flex space-x-4">
            <a href="#" className="clickable hover:text-blue-500">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="clickable hover:text-blue-400">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="clickable hover:text-pink-500">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="clickable hover:text-red-500">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="text-center mt-8 pt-4 border-t border-gray-900">
        <p>{t('footer.copyright', { year: currentYear })}</p>
      </div>
    </footer>
  );
}

export default Footer;